import swaggerClient from "../remote-client";
import Utils from "../Utils";

export default class ProfileServiceImpl {
  changePassword(payload) {
    return swaggerClient.userSwaggerClient
      .then(
        client => {
          return client.apis.UserHealthFacility.postHfUserPasswordChange(
            {},
            swaggerClient.buildRequest(payload),
            {}
          );
        },
        () => {
          return Promise.reject({ type: Utils.errorTypes.UNABLE_TO_CALL_API });
        }
      )
      .then(
        result => {
          return result.body;
        },
        reason => {
          return Promise.reject({ type: Utils.errorTypes.STATUS, reason });
        }
      );
  }
}
